import { render } from "./Trainer.vue?vue&type=template&id=48b5be6c"
import script from "./Trainer.vue?vue&type=script&lang=js"
export * from "./Trainer.vue?vue&type=script&lang=js"

import exportComponent from "/Users/teguhsangra/Web/GSD/xsport/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__